import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { useEffect, useRef, useState } from "react";
import { ReactCropperElement } from "react-cropper";
import { storage } from "../../../firebaseConfig";
import { base64ToBlob, getFileUrl } from "../../../hooks/utils";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { pushModal, resetModals } from "../../../store/slices/modalsSlice";
import ImageUploaderPopup from "../../TutorRegistration/ImageUploaderPopup";
import FileUploadProgressBar from "../FileUploadProgressBar";

const UpdatePortalImages = ({
  userData,
  setUserData,
  imgType,
}: {
  userData: any;
  setUserData: (x: any) => void;
  imgType: "profile_pic" | "logo";
}) => {
  const imageRef = useRef(null);
  const [error, setError] = useState("");
  const [fileProgress, setFileProgress] = useState(null);
  const dispatch = useAppDispatch();
  const {
    user: { uid },
  } = useAppSelector((state) => state.store);
  const [image, setImage] = useState<string>(userData?.[imgType]);
  const [cropData, setCropData] = useState("");
  const cropperRef = useRef<ReactCropperElement>();

  const onChange = (e: any) => {
    e.preventDefault();
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }
    const reader = new FileReader();
    reader.onload = () => {
      setImage(reader.result as any);
    };
    reader.readAsDataURL(files[0]);
  };

  const getCropData = () => {
    if (typeof cropperRef.current?.cropper !== "undefined") {
      setCropData(cropperRef.current?.cropper.getCroppedCanvas().toDataURL());
      dispatch(resetModals());
    } else {
      // the react-cropper package couldn't get the value of cropperRef or assign a value to it
      // this is a workaround to get the cropped image which is an instance of ReactCropperElement
      // which extends HTMLImageElement and adds a cropper (that has the cropper functionality) as a property to it
      // by using the DOM element directly
      // and to achieve that I had to clone the react-cropper package, edit and build it then use it in this project
      // you can find the updated package here: https://github.com/saifsalemm/qashqool-react-cropper
      const el = document.getElementById(
        "qashqool-react-cropper-img"
      ) as ReactCropperElement;
      setCropData(el?.cropper.getCroppedCanvas().toDataURL());
      dispatch(resetModals());
    }
  };

  useEffect(() => {
    if (image !== userData?.[imgType] && !cropData) handleOpenPopup();
  }, [image]);

  useEffect(() => {
    if (cropData) handleUploadFb();
  }, [cropData]);

  const handleUploadFb = () => {
    if (image === imgType) return;

    const imageRef = ref(
      storage,
      `${imgType === "logo" ? "logos" : "profile_pics"}-${uid}`
    );
    const uploadTask = uploadBytesResumable(imageRef, base64ToBlob(cropData));

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setFileProgress(progress.toFixed(2));
      },
      (error) => {
        console.log(error);
        setError("حدث خطأ");
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          console.log("cweafwq", imgType, downloadURL, getFileUrl(downloadURL));
          setUserData((prev) => ({
            ...prev,
            [imgType]: getFileUrl(downloadURL),
          }));
          setFileProgress(null);
        });
      }
    );
  };

  const handleOpenPopup = () => {
    dispatch(
      pushModal(
        <ImageUploaderPopup
          image={image}
          cropperRef={cropperRef}
          getCropData={getCropData}
        />
      )
    );
  };

  return (
    <>
      {fileProgress ? (
        <FileUploadProgressBar fileProgress={fileProgress} />
      ) : (
        <>
          <img
            src={
              userData?.[imgType]
                ? userData?.[imgType]
                : "https://eliteacademymedia.s3.us-east-1.amazonaws.com/placeholder-profile-image-2.png"
            }
            alt="upload"
            className="rounded-lg mx-auto cursor-pointer border border-gray-300 w-40 aspect-square object-cover p-2"
            onClick={() => {
              setCropData("");
              imageRef.current.click();
            }}
          />
          <input
            ref={imageRef}
            type="file"
            accept="image/jpeg, image/jpg, image/png"
            className="hidden"
            onChange={onChange}
          />
        </>
      )}
    </>
  );
};

export default UpdatePortalImages;
